import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import * as systemActions from '../../store/actions/system.actions'
import {
  IconCadastrosWhite,
  IconChecklistWhite,
  IconCodigoBarraWhite,
  IconDashboardWhite,
  IconDocumentacaoWhite,
  IconEntregasWhite,
  IconEstoqueWhite,
  IconHomeWhite,
  IconInsumoWhite,
  IconOrdemColetaWhite,
  IconPatrimonioWhite,
  IconProcessosWhite,
  LogoLogin,
} from '../../assets/imgs'
import './Sidebar.css'

class Sidebar extends Component {
  state = {
    menuItems: [
      { name: 'Home', path: '/main/home', icon: IconHomeWhite },
      {
        name: 'Documentação',
        path: '/main/documentacao/menu',
        icon: IconDocumentacaoWhite,
      },
      {
        name: '1. Dashboard',
        path: '/main/dashboard/menu',
        icon: IconDashboardWhite,
      },
      {
        name: '2. Cadastros',
        path: '/main/cadastros/menu',
        icon: IconCadastrosWhite,
      },
      {
        name: '3. Entregas',
        path: '/main/entregas/menu',
        icon: IconEntregasWhite,
      },
      {
        name: '4. Picking',
        path: '/main/picking/menu',
        icon: IconCodigoBarraWhite,
      },
      {
        name: '5. Ordem de Coleta',
        path: '/main/ordemcoleta/menu',
        icon: IconOrdemColetaWhite,
      },
      {
        name: '6. Patrimônio',
        path: '/main/patrimonio/menu',
        icon: IconPatrimonioWhite,
      },
      { name: '7. Insumo', path: '/main/insumo/menu', icon: IconInsumoWhite },
      {
        name: '8. Estoque',
        path: '/main/estoque/menu',
        icon: IconEstoqueWhite,
      },
      {
        name: '9. Gestão de Pátio',
        path: '/main/patio/menu',
        icon: IconProcessosWhite,
      },
      {
        name: '10. Checklist',
        path: '/main/checklist-operacional/menu',
        icon: IconChecklistWhite,
      },
    ],
  }
  // ***********************************
  // Events
  // ***********************************
  onBackdropClicked = () => {
    this.props.dispatch(systemActions.showSidebar(false))
  }
  onSidebarItemClicked = ({ name, path }) => {
    this.props.history.push(path)
    this.props.dispatch(systemActions.activedPageChange(name))
  }

  // ***********************************
  // Live cicles
  // ***********************************
  render() {
    const { menuItems } = this.state
    const {
      system: { showSidebar },
    } = this.props
    const elementClass = showSidebar
      ? 'Sidebar__container bck-primary  sidebarContainer__active'
      : 'Sidebar__container bck-primary'
    return (
      <div className="Sidebar">
        <div className={elementClass}>
          <header>
            <img width="100" src={LogoLogin} alt="Logo - Co-Log" />
          </header>
          <div className="text-center" style={{ marginTop: 10 }}>
            <small style={{ color: 'white' }}>{process.env.REACT_APP_VERSION || '2.2.84'}</small>
          </div>
          <div style={{ marginTop: 15 }}>{menuItems.map(item => this._getSidebarItem(item))}</div>
        </div>
        <div className="Sidebar__backdrop" onClick={this.onBackdropClicked}></div>
      </div>
    )
  }
  // ***********************************
  // Helpers
  // ***********************************
  _getSidebarItem = item => {
    const {
      system: { activedPage },
    } = this.props
    return (
      <div key={item.name} className="SidebarItem" onClick={() => this.onSidebarItemClicked(item)}>
        <div className={item.name === activedPage ? 'item-tag bck-secondary' : 'item-tag'}></div>
        <div className="item-icon">
          <img src={item.icon} alt="item icon" />
        </div>
        <div className="item-label">{item.name}</div>
      </div>
    )
  }
}
const mapStateToProps = ({ system }) => ({ system })
export default connect(mapStateToProps)(withRouter(Sidebar))
